<div class="input-component"
     *ngIf="status.invalid ; else noFailure">
    <div class="error">{{ status.error | translate}}</div>
</div>
<ng-template #noFailure>
    <div>&nbsp;</div>
</ng-template>
